import React from 'react';
import { Star, Package, Hash, FileText, Link, Image } from 'lucide-react';

const SpecialFormFields = ({ formik }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="bg-gradient-to-r from-purple-500 to-indigo-500 h-1 -mx-6 -mt-6 mb-6 rounded-t-lg"></div>
      
      <h3 className="text-lg font-semibold text-gray-900 mb-6 flex items-center gap-2">
        <Package className="h-5 w-5 text-purple-600" />
        Informações do Especial
      </h3>

      <form onSubmit={formik.handleSubmit} className="space-y-6">
        {/* Nome */}
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
            <FileText className="inline h-4 w-4 mr-1" />
            Nome do Especial *
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-colors ${
              formik.touched.name && formik.errors.name
                ? 'border-red-300 bg-red-50'
                : 'border-gray-300'
            }`}
            placeholder="Ex: Pizza Margherita"
          />
          {formik.touched.name && formik.errors.name && (
            <p className="mt-1 text-sm text-red-600">{formik.errors.name}</p>
          )}
        </div>

        {/* Slug */}
        <div>
          <label htmlFor="slug" className="block text-sm font-medium text-gray-700 mb-2">
            <Link className="inline h-4 w-4 mr-1" />
            Slug *
          </label>
          <input
            type="text"
            id="slug"
            name="slug"
            value={formik.values.slug}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-colors font-mono text-sm ${
              formik.touched.slug && formik.errors.slug
                ? 'border-red-300 bg-red-50'
                : 'border-gray-300'
            }`}
            placeholder="pizza-margherita"
          />
          {formik.touched.slug && formik.errors.slug && (
            <p className="mt-1 text-sm text-red-600">{formik.errors.slug}</p>
          )}
          <p className="mt-1 text-xs text-gray-500">
            URL amigável para o especial (gerado automaticamente)
          </p>
        </div>

        {/* Descrição */}
        <div>
          <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2">
            <FileText className="inline h-4 w-4 mr-1" />
            Descrição
          </label>
          <textarea
            id="description"
            name="description"
            rows="4"
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-colors resize-none"
            placeholder="Descreva os detalhes do especial..."
          />
          {formik.touched.description && formik.errors.description && (
            <p className="mt-1 text-sm text-red-600">{formik.errors.description}</p>
          )}
        </div>

        {/* Grid para Peso e Popular */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Peso */}
          <div>
            <label htmlFor="weight" className="block text-sm font-medium text-gray-700 mb-2">
              <Hash className="inline h-4 w-4 mr-1" />
              Peso
            </label>
            <input
              type="number"
              id="weight"
              name="weight"
              min="0"
              step="0.1"
              value={formik.values.weight}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-colors ${
                formik.touched.weight && formik.errors.weight
                  ? 'border-red-300 bg-red-50'
                  : 'border-gray-300'
              }`}
              placeholder="0"
            />
            {formik.touched.weight && formik.errors.weight && (
              <p className="mt-1 text-sm text-red-600">{formik.errors.weight}</p>
            )}
            <p className="mt-1 text-xs text-gray-500">
              Peso para ordenação (opcional)
            </p>
          </div>

          {/* Popular */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <Star className="inline h-4 w-4 mr-1" />
              Status
            </label>
            <div className="flex items-center h-12 px-4 border border-gray-300 rounded-lg bg-gray-50">
              <input
                type="checkbox"
                id="is_popular"
                name="is_popular"
                checked={formik.values.is_popular}
                onChange={formik.handleChange}
                className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300 rounded"
              />
              <label htmlFor="is_popular" className="ml-3 text-sm font-medium text-gray-700">
                Especial Popular
              </label>
            </div>
            <p className="mt-1 text-xs text-gray-500">
              Marque se este é um especial em destaque
            </p>
          </div>
        </div>

        {/* URL da Imagem */}
        <div>
          <label htmlFor="image" className="block text-sm font-medium text-gray-700 mb-2">
            <Image className="inline h-4 w-4 mr-1" />
            URL da Imagem
          </label>
          <input
            type="url"
            id="image"
            name="image"
            value={formik.values.image}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-colors ${
              formik.touched.image && formik.errors.image
                ? 'border-red-300 bg-red-50'
                : 'border-gray-300'
            }`}
            placeholder="https://exemplo.com/imagem.jpg"
          />
          {formik.touched.image && formik.errors.image && (
            <p className="mt-1 text-sm text-red-600">{formik.errors.image}</p>
          )}
          <p className="mt-1 text-xs text-gray-500">
            URL completa da imagem do especial (opcional)
          </p>
        </div>

        {/* Botão de Submit (escondido - será acionado pelo header) */}
        <button type="submit" className="hidden" />
      </form>
    </div>
  );
};

export default SpecialFormFields;